import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import './CountBadge.scss';

export interface ICountBadgeProps {
    /** Содержимое пилюли: число, «99+» или компонент с анимированным значением. */
    children: ReactNode;
    /** Дополнительный класс — им вызывающая сторона задаёт позиционирование. */
    className?: string;
    /** Подсказка при наведении. */
    title?: string;
}

/**
 * Пилюля-счётчик поверх управляющего элемента: колокольчик уведомлений в шапке,
 * кнопка «Действия» в карточке документа. Один вид на оба места — раньше он был
 * скопирован в Navbar.scss и DocumentActionsMenu.scss и успел разойтись
 * интерлиньяжем.
 *
 * Компонент отвечает ТОЛЬКО за вид. Формат значения и анимацию держит вызывающая
 * сторона.
 *
 * Не путать с FolderCountBadge: тот крупнее (20px), красится в цвет сайдбара и
 * сам решает, показывать ли значение.
 */
export const CountBadge: FC<ICountBadgeProps> = ({ children, className, title }) => (
    <span className={clsx('rf-count-badge', className)} title={title}>
        {children}
    </span>
);
